/**
 * Shared width of the Action column, as a percentage, for every table on the Devices page.
 *
 * Each tab renders several tables one above another in the same container, all `width: 100%`,
 * so equal percentages are equal pixels. The Action column is the rightmost thing on each
 * row, which makes a mismatch conspicuous: a trigger sitting slightly left of the one above
 * it reads as a table subtly broken, not as a different table. One value rather than one per
 * tab, so the column also holds its place when you switch tabs.
 *
 * The invariant every table has to hold is that its remaining columns fill
 * `100 - ACTION_COLUMN_WIDTH`.
 *
 * It lives in its own module because no table owns the alignment — it is a property of the
 * page. Sized for the widest thing that goes in the column, the "Actions" menu trigger.
 */
export const ACTION_COLUMN_WIDTH = 13;
